import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { handleIdentityLogin, loginSelector } from "../../store/features/auth/authSlice";
import { IDENTITY_CLIENT_ID } from "../../../utils/constant";

const getCode = searchParams => {
  if (searchParams.has("code")) {
    return searchParams.get("code");
  }
  return "";
};

const Identity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector(loginSelector);
  const [searchParams] = useSearchParams();
  const [setHelperText] = useState("");

  useEffect(() => {
    if (isAuthenticated && user) {
      if (location.state?.from) navigate(location.state.from.pathname + location.state.from.search, { replace: true });
      else if (user.isApprentice) navigate("/dashboard");
      else navigate("/wps-time-allocation");
    } else {
      dispatch(
        handleIdentityLogin({ code: getCode(searchParams), identityClientId: IDENTITY_CLIENT_ID }, error => {
          setHelperText(error);
        })
      );
    }
  }, [isAuthenticated]);
};

export default Identity;
